




































import { AssortmentUpdateApi } from "@/api";
import stateMixin, { StateMixin } from "@/mixins/state";
import Vue, { VueConstructor } from "vue";
import {
  downloadDocument,
  getFileNameFromContentDispositionHeader
} from "@/util/download";
import { toLocalDateTimeString } from "@/util/date";

export default (Vue as VueConstructor<Vue & StateMixin>).extend({
  data() {
    return {
      data: null,
      toLocalDateTimeString,
      fileDate: ""
    };
  },
  name: "AssortmentUpdate",
  mixins: [stateMixin],
  async mounted() {
    await this.getLastWriteTime();
  },
  methods: {
    getLastWriteTime: async function() {
      const api = new AssortmentUpdateApi();
      const { data } = await api.assortmentUpdateGetLatestAssortmentWriteTime();
      if (data !== null) {
        this.fileDate = data;
      }
    },
    downloadExcel: async function() {
      const api = new AssortmentUpdateApi();
      const {
        data,
        headers
      } = await api.assortmentUpdateDownloadAssortmentUpdate({
        responseType: "arraybuffer"
      });

      var fileName = getFileNameFromContentDispositionHeader(
        headers["content-disposition"]
      );

      downloadDocument(data, headers, fileName);
    },
    fetch: async function() {
      this.setState(this.states.LOADING);
      try {
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    }
  }
});
